// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ll1u","expireSoon":"styles_expireSoon__27gYC"};